import './index.scss';

import React from 'react';
import _ from 'lodash';
import TextToast from './TextToast';
import UndoToast from './UndoToast';
import DefaultToast from './DefaultToast';

class MainToast extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { onUndo, label, children, ...otherProps } = this.props;

    if (onUndo) {
      return <UndoToast onUndo={onUndo} label={label} {...otherProps} />;
    }

    if (label) {
      return <TextToast label={label} {...otherProps} />;
    }

    return <DefaultToast {...otherProps}>{children}</DefaultToast>;
  }
}

export default MainToast;
